<template>
  <CreateOrderLayout>
    <div class="kt-portlet">
      <div class="kt-portlet__head">
        <div class="kt-portlet__head-label">
          <h3 class="kt-portlet__head-title">
            Pick a delivery time
            <small>
              How fast would you like us to delivered your process images?
            </small>
          </h3>
        </div>
      </div>
      <div class="kt-portlet__body">
        <div class="row no-gutters justify-content-md-center">
          <div
            class="col-md-3 px-2 py-2"
            v-for="deliveryTime in deliveryTimes"
            :key="deliveryTime.id"
          >
            <label
              class="kt-option p-0"
              :class="[
                deliveryTime.id === deliveryTimeModel ? 'border-blue' : '',
              ]"
            >
              <span style="display: none" class="kt-option__control mt-4 mb-2">
                <span class="kt-radio kt-radio--brand">
                  <input
                    type="radio"
                    v-model="deliveryTimeModel"
                    :value="deliveryTime.id"
                  />
                  <span></span>
                </span>
              </span>
              <span class="kt-option__label">
                <span class="kt-option__head">
                  <img
                    class="rounded-top mx-auto"
                    :src="deliveryTime.sample"
                    alt
                  />
                </span>
                <span class="kt-option__body text-center">
                  <h4>{{ deliveryTime.title }}</h4>
                  <strong>{{ deliveryTime.description }}</strong>
                </span>
              </span>
            </label>
          </div>
        </div>
      </div>
    </div>
  </CreateOrderLayout>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import CreateOrderLayout from "@/layouts/CreateOrderLayout.vue";
import BeforeLeaveOrderFormMixin from "@/mixins/beforeLeaveOrderForm.js";

export default {
  name: "StepFour",
  components: {
    CreateOrderLayout,
  },
  mixins: [BeforeLeaveOrderFormMixin],
  data() {
    return {
      deliveryTimeModel: null,
    };
  },
  computed: {
    ...mapGetters({
      service: "service/service",
      deliveryTimes: "service/deliveryTimes",
      orderDeliveryTimeId: "order/deliveryTimeId",
    }),
  },
  watch: {
    deliveryTimeModel(newValue) {
      this.setDeliveryTime({
        timeId: newValue,
      });
    },
  },
  mounted() {
    this.deliveryTimeModel = this.orderDeliveryTimeId;
  },
  methods: {
    ...mapActions({
      setDeliveryTime: "order/setDeliveryTime",
    }),
  },
};
</script>
